export enum BudgetStatus {
    SCHEDULED = 'SCHEDULED',
    STARTED = 'STARTED',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
    ABORTED = 'ABORTED',
}
